<div class="visual-aid-container"
  [ngClass]="{ preloader: isLoading }"
  [class.no-hint]="!callStore.getHints()"
  [class.is-ipad]="callStore.getIsIpad()"
  [class.fullscreen]="callStore.getIsFullScreen()">
  <div *ngIf="isLoading" class="image-wrapper loading-state">
    <qai-call-audio-indicator size="medium" status="loading" />
  </div>
  <div *ngIf="!isLoading" class="image-wrapper">
    <img
      qai-image
      [src]="visualAidImageUrl"
      [alt]="'call.VISUAL_AID_LOAD_ERROR' | transloco"  />
    <app-visual-aid-next-page-navigator
      [canContinueNext]="canContinueNext"
      [isAvatarSpeaking]="callStore.getIsAvatarSpeaking()"
      (nextClicked)="handleContinueClick()"
      (fullScreenClicked)="handleFullScreenClick()"
    ></app-visual-aid-next-page-navigator>
  </div>

</div>
